"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VECTOR_COLORS = void 0;
var theme_1 = __importDefault(require("../../theme"));
exports.DEFAULT_VECTOR_COLORS = {
    dark: theme_1.default.colorsPalette.blue.dark,
    default: theme_1.default.colorsPalette.blue.default,
    light: theme_1.default.colorsPalette.blue.light,
};
//# sourceMappingURL=index.js.map